import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import Drafts from '@/components/screens/drafts/Drafts';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IDrafts } from '@/interfaces/drafts.interface';

interface IDraftsPageProps {
  books: IDrafts;
}

const DraftsPageDynamic: NextPage<IDraftsPageProps> = ({ books }) => {
  return <Drafts books={books} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const res = await fetch(`${API_URL}satellite/books/drafts?page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default DraftsPageDynamic;
